import { Base2Presenter } from "core/presenter";
import MyFinanceService from "./my-finance.service";
import { pathOr } from "ramda";
class PresenterMyFinance extends Base2Presenter {
  initialState() {
    const { company } = this.props;
    const { integrations } = company;
    return {
      loading: false,
      company: {
        ...company,
        integrations: {
          ...integrations,
          my_finance: {
            enabled: false,
            token: "",
            account_id: "",
            entity_id: ""
          }
        }
      },
      accounts: [],
      entities: [],
      pendingTransactionsOpen: false
    };
  }

  async onStart() {
    await this.checkIntegration();
  }

  checkIntegration() {
    const { company } = this.props;
    const { integrations } = company;
    const { my_finance } = integrations;

    if (my_finance) {
      this.enqueue(vm => ({
        company: {
          ...vm.company,
          integrations: {
            my_finance
          }
        }
      }));
    }

    const integrationEnabled = pathOr(
      false,
      ["integrations", "my_finance", "enabled"],
      company
    );
    this.setMyFinanceField(
      "enabled",
      integrationEnabled,
      async () => await this.onTokenFilled()
    );
  }

  async onTokenFilled() {
    const token = this.viewModel.company.integrations.my_finance.token;
    if (!token || token.length < 48) {
      return;
    }

    this.setField("loading", true);

    const result = await MyFinanceService.acquireAccounts(token);

    if (result.success) {
      const accounts = result.data.map(res => ({
        id: res.account.id,
        name: res.account.name
      }));

      this.setField("accounts", accounts);

      const { company } = this.viewModel;
      const { integrations } = company;
      const { my_finance } = integrations;
      const { account_id } = my_finance;

      if (account_id) {
        this.setMyFinanceField(
          "account_id",
          account_id,
          async () => await this.getEntities()
        );
        this.updateMyFinanceIntegration();
      } else {
        this.setMyFinanceField(
          "account_id",
          accounts[0].id,
          await this.getEntities()
        );
      }
    } else {
      this.setField("accounts", []);
      this.setField("entities", []);

      const message = {
        token:
          "Parece que esse token é inválido. Por favor, verifique se copiou corretamente.",
        connection:
          "Houve um problema na conexão com o MyFinance. Por favor, tente novamente mais tarde ou entre em contato com o suporte."
      };

      this.sendNotification({
        type: "error",
        title: "Oops",
        content:
          result.data.trim() === "Retry later"
            ? message.connection
            : message.token
      });

      this.setField("loading", false);
    }
  }

  async getEntities() {
    const token = this.viewModel.company.integrations.my_finance.token;
    const accountId = this.viewModel.company.integrations.my_finance.account_id;

    const result = await MyFinanceService.acquireEntities(token, accountId);

    if (result.success) {
      const entities = result.data.map(res => ({
        id: res.entity.id,
        name: res.entity.name
      }));

      this.setField("entities", entities);

      const { company } = this.viewModel;
      const { integrations } = company;
      const { my_finance } = integrations;
      const { entity_id } = my_finance;

      if (entity_id) {
        this.setMyFinanceField(
          "entity_id",
          entity_id,
          this.updateMyFinanceIntegration()
        );
      }
    } else {
      this.setField("entities", []);
      this.sendNotification({
        type: "error",
        title: "Oops",
        content: "Houve algum problema com as entidades do MyFinance."
      });
    }
    this.setField("loading", false);
  }

  manageCheckbox(checked) {
    this.setField("loading", true);
    this.setMyFinanceField("enabled", checked, () =>
      this.updateMyFinanceIntegration()
    );
    this.setField("loading", false);
  }

  updateMyFinanceIntegration() {
    const { company } = this.viewModel;
    const { integrations } = company;
    const { my_finance } = integrations;

    const updatedIntegration = {
      enabled: my_finance.enabled,
      token: my_finance.token,
      account_id: my_finance.account_id,
      entity_id: my_finance.entity_id
    };

    this.props.updateVmMyFinanceIntegration(updatedIntegration);
  }

  onPendingTransactionsOpen() {
    this.enqueue({ pendingTransactionsOpen: true });
  }

  onPendingTransactionsClose() {
    this.enqueue({ pendingTransactionsOpen: false });
  }

  setMyFinanceField(field, value, callback = () => {}) {
    this.enqueue(
      vm => ({
        company: {
          ...vm.company,
          integrations: {
            ...vm.company.integrations,
            my_finance: {
              ...vm.company.integrations.my_finance,
              [field]: value
            }
          }
        }
      }),
      () => callback()
    );
  }

  setField(field, value) {
    this.enqueue({ [field]: value });
  }

  setToken(value) {
    this.setMyFinanceField("token", value, () => this.onTokenFilled());
  }

  setAccount(value) {
    this.setMyFinanceField("account_id", value, () => this.getEntities());
  }

  setEntity(value) {
    this.setMyFinanceField("entity_id", value, () =>
      this.updateMyFinanceIntegration()
    );
  }
}

export default PresenterMyFinance;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/integrations/my-finance/presenter.js